import { useState, useEffect } from "react";
import "../styles/celebrations.css";

export default function Celebration({ cue, type }) {
	const [show, setShow] = useState(false);

	useEffect(() => {
		if (cue.type === "celebration") {
			setShow(true);
		} else {
			if (
				(cue.chat.snippet.type === "superChatEvent" ||
					cue.chat.snippet.type === "newSponsorEvent") &&
				(cue.status === "coming" || cue.status === "onair")
			) {
				setShow(true);
			} else {
				setShow(false);
			}
		}
	}, [cue]);

	return (
		<div
			className="w-screen h-screen overflow-hidden absolute
    "
		>
			{type === "none" && ""}
			{type === "balloons" && <Balloons status={show} />}
			{type === "money" && <Money status={show} />}
			{type === "confetti" && <Confetti status={show} />}
			{type === "emoji" && <Emoji status={show} emjoi={cue.emoji} />}
		</div>
	);
}

const Balloons = ({ status }) => {
	return (
		<>
			<div
				className={`balloons-holder ${
					status === true ? "balloons-animate" : "hidden"
				}`}
			>
				<span className="balloon-svg" data-index="1"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="3"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="1"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="3"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="1"></span>
			</div>
			<div
				className={`balloons-holder ${status === true && "balloons-animate"}`}
			>
				<span className="balloon-svg" data-index="1"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="3"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="1"></span>
				<span className="balloon-svg" data-index="3"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="3"></span>
				<span className="balloon-svg" data-index="4"></span>
				<span className="balloon-svg" data-index="2"></span>
				<span className="balloon-svg" data-index="1"></span>
			</div>
		</>
	);
};

const MoneySVG = () => {
	return (
		<svg
			width="289"
			height="127"
			viewBox="0 0 289 127"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="8" y="8" width="273" height="110" rx="8" fill="#5CDA59" />
			<path
				d="M281.5 17C281.5 20.9933 281.845 24.583 282.137 27.6343C282.159 27.8556 282.18 28.074 282.2 28.2896C282.514 31.5797 282.701 34.0024 282.444 35.8722C282.208 37.5853 281.647 38.5054 280.619 39.1459C279.393 39.9105 277.146 40.5001 273 40.5001C257.182 40.5001 244.5 28.1112 244.5 13.0001C244.5 8.8809 244.956 6.88259 245.505 5.93614C245.728 5.55229 245.94 5.38888 246.157 5.2854C246.42 5.1597 246.857 5.04717 247.615 5.03658C248.955 5.01785 250.619 5.29687 252.949 5.68741C253.473 5.77522 254.03 5.86866 254.625 5.96562C257.728 6.47144 261.522 7 266 7C269.421 7 272.236 6.8396 274.459 6.71295C275.07 6.67812 275.636 6.64584 276.158 6.62015C277.394 6.55933 278.329 6.53784 279.07 6.582C279.818 6.62651 280.202 6.73077 280.401 6.8195C280.405 6.82157 280.411 6.82369 280.417 6.82611C280.525 6.86748 280.865 6.99879 281.134 8.49894C281.437 10.1834 281.5 12.7925 281.5 17Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
			<path
				d="M269.3 119.2C265.307 119.2 261.717 119.545 258.666 119.838C258.444 119.859 258.226 119.88 258.01 119.9C254.72 120.214 252.298 120.401 250.428 120.144C248.715 119.908 247.795 119.347 247.154 118.319C246.389 117.093 245.8 114.846 245.8 110.7C245.8 94.8822 258.189 82.2002 273.3 82.2002C277.419 82.2002 279.417 82.6565 280.364 83.2053C280.748 83.4279 280.911 83.6404 281.015 83.8571C281.14 84.1203 281.253 84.5569 281.263 85.3148C281.282 86.6551 281.003 88.3195 280.613 90.6491C280.525 91.1729 280.431 91.7303 280.334 92.3252C279.828 95.4285 279.3 99.2219 279.3 103.7C279.3 107.121 279.46 109.936 279.587 112.159C279.622 112.77 279.654 113.336 279.68 113.858C279.741 115.094 279.762 116.029 279.718 116.771C279.673 117.518 279.569 117.902 279.48 118.101C279.478 118.106 279.476 118.111 279.474 118.117C279.432 118.225 279.301 118.565 277.801 118.835C276.117 119.137 273.507 119.2 269.3 119.2Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
			<path
				d="M10.2642 107C10.2642 103.007 9.91962 99.4171 9.62676 96.3658C9.60552 96.1445 9.58456 95.9261 9.56402 95.7106C9.25046 92.4204 9.063 89.9977 9.32048 88.1279C9.55639 86.4148 10.1175 85.4947 11.145 84.8542C12.3716 84.0896 14.6183 83.5001 18.7642 83.5001C34.5822 83.5001 47.2642 95.8889 47.2642 111C47.2642 115.119 46.8079 117.118 46.2591 118.064C46.0365 118.448 45.8239 118.611 45.6073 118.715C45.3441 118.84 44.9074 118.953 44.1495 118.964C42.8093 118.982 41.1449 118.703 38.8152 118.313C38.2915 118.225 37.7341 118.131 37.1392 118.034C34.0358 117.529 30.2425 117 25.7642 117C22.3431 117 19.5281 117.161 17.3056 117.287C16.6943 117.322 16.1279 117.354 15.6059 117.38C14.37 117.441 13.4353 117.462 12.6937 117.418C11.9463 117.374 11.562 117.269 11.3633 117.181C11.3587 117.179 11.3532 117.176 11.3469 117.174C11.2396 117.133 10.8991 117.001 10.6297 115.501C10.3272 113.817 10.2642 111.208 10.2642 107Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
			<path
				d="M20.4642 6.56396C24.4575 6.56396 28.0473 6.21942 31.0986 5.92656C31.3198 5.90533 31.5382 5.88436 31.7538 5.86382C35.0439 5.55026 37.4666 5.3628 39.3364 5.62028C41.0495 5.85619 41.9696 6.4173 42.6102 7.44484C43.3748 8.67144 43.9643 10.9181 43.9643 15.064C43.9643 30.882 31.5755 43.564 16.4643 43.564C12.3451 43.564 10.3468 43.1077 9.40038 42.5589C9.01652 42.3363 8.85311 42.1237 8.74963 41.9071C8.62394 41.6439 8.5114 41.2072 8.50081 40.4493C8.48208 39.1091 8.7611 37.4447 9.15165 35.115C9.23945 34.5913 9.33289 34.0339 9.42985 33.439C9.93568 30.3356 10.4642 26.5423 10.4642 22.064C10.4642 18.6429 10.3038 15.8279 10.1772 13.6054C10.1423 12.9941 10.1101 12.4277 10.0844 11.9057C10.0236 10.6698 10.0021 9.73508 10.0462 8.99347C10.0907 8.24607 10.195 7.86179 10.2837 7.66311C10.2858 7.65849 10.2879 7.65299 10.2903 7.6467C10.3317 7.53942 10.463 7.19889 11.9632 6.92948C13.6476 6.62698 16.2567 6.56396 20.4642 6.56396Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
			<path
				d="M111.5 6.89339C91.8999 4.89339 33.9999 6.06005 7.49989 6.89339C3.99989 13.3935 7.49989 47.3933 7.49989 55.8933C7.49989 64.3933 7.49989 108.393 10.9999 115.893C14.4999 123.393 23.9999 118.393 38.4999 120.393C52.9999 122.393 55.9999 117.893 67.4999 118.393C78.9999 118.893 114 123.393 125 120.393C136 117.393 217 120.393 224.5 120.393C232 120.393 273.5 121.893 279.5 120.393C285.5 118.893 282 84.8933 282 79.8933C282 74.8933 282.5 32.8933 282 27.3933C281.5 21.8933 282 9.89333 279.5 6.89339C277 3.89344 209.5 4.89333 198.5 6.89339C187.5 8.89344 136 9.39339 111.5 6.89339Z"
				stroke="#1D681B"
				strokeWidth="10"
			/>
			<path
				d="M183 63C183 83.2179 165.761 100 144 100C122.239 100 105 83.2179 105 63C105 42.7821 122.239 26 144 26C165.761 26 183 42.7821 183 63Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="10"
			/>
			<path
				d="M242.5 63C242.5 70.8754 235.697 77.5 227 77.5C218.303 77.5 211.5 70.8754 211.5 63C211.5 55.1246 218.303 48.5 227 48.5C235.697 48.5 242.5 55.1246 242.5 63Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
			<path
				d="M76.5 63C76.5 70.8754 69.697 77.5 61 77.5C52.303 77.5 45.5 70.8754 45.5 63C45.5 55.1246 52.303 48.5 61 48.5C69.697 48.5 76.5 55.1246 76.5 63Z"
				fill="#9C9C9C"
				stroke="#1D681B"
				strokeWidth="5"
			/>
		</svg>
	);
};

const Money = ({ status }) => {
	let array = [
		10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9, 10, 2, 4, 6, 4,
		6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9, 9, 2, 5, 6, 1,
		7, 7, 9, 8, 8, 9, 8, 7, 5, 7,
	];
	return (
		<div
			className={`money-holder ${status === true ? "money-animate" : "hidden"}`}
		>
			{array.map((item, index) => {
				let delay = (index - item) / 100;
				return (
					<span
						style={{
							animationDelay: `${delay}s`,
							margin: `-${delay * 15}vw -3vw`,
						}}
						className="money-svg"
						key={index}
						data-index={item}
					>
						<MoneySVG />
					</span>
				);
			})}
		</div>
	);
};

const confettiColours = [
	"#B90E93",
	"#333333",
	"#03DDEB",
	"#E3F700",
	"#333333",
	"#B90E93",
	"#E3F700",
	"#B90E93",
	"#03DDEB",
	"#333333",
	"#03DDEB",
	"#E3F700",
];

const ConfettiSVGTriangle = ({ rand, col }) => {
	return (
		<svg
			style={{
				transitionDelay: `${rand}s`,
				transitionDuration: `${rand}s !important`,
			}}
			width="40"
			height="35"
			viewBox="0 0 40 35"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M20 0L39.9186 34.5H0.0814152L20 0Z" fill={col} />
		</svg>
	);
};

const ConfettiSVGSqwiggle = ({ rand, col }) => {
	return (
		<svg
			style={{
				transitionDelay: `${rand}s`,
				transitionDuration: `${rand}s !important`,
			}}
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.89096 1C3.89096 1 1.51892 9.40126 4.5156 12.9783C7.99495 17.1314 14.5807 10.2632 18.2577 14.2391C21.6032 17.8567 16.2943 23.1095 19.507 26.8478C22.6472 30.5019 28.8768 29.3696 32 30"
				stroke={col}
				strokeWidth="5"
			/>
		</svg>
	);
};

const ConfettiSVGSquare = ({ rand, col }) => {
	return (
		<svg
			style={{
				transitionDelay: `${rand}s`,
				transitionDuration: `${rand}s !important`,
			}}
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="34" height="34" fill={col} />
		</svg>
	);
};

const ConfettiSVGDot = ({ rand, col }) => {
	return (
		<svg
			style={{
				transitionDelay: `${rand}s`,
				transitionDuration: `${rand}s !important`,
			}}
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="17" cy="17" r="17" fill={col} />
		</svg>
	);
};

const Confetti = ({ status }) => {
	let array = [
		10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9, 10, 2, 4, 6, 4,
		6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9, 9, 2, 5, 6, 1,
		7, 7, 9, 8, 8, 9, 8, 7, 5, 7, 10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2,
		8, 5, 1, 7, 9, 10, 2, 4, 6, 4, 6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8,
		1, 6, 2, 3, 9, 9, 2, 5, 6, 1, 7, 7, 9, 8, 8, 9, 8, 7, 5, 7, 10, 6, 7, 6, 9,
		3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9, 10, 2, 4, 6, 4, 6, 9, 1, 5, 6,
		1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9, 9, 2, 5, 6, 1, 7, 7, 9, 8, 8,
		9, 8, 7, 5, 7, 10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9,
		10, 2, 4, 6, 4, 6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9,
		9, 2, 5, 6, 1, 7, 7, 9, 8, 8, 9, 8, 7, 5, 7,
	];

	return (
		<div
			className={`confetti-holder ${
				status === true ? "confetti-animate" : "hidden"
			} `}
		>
			{array.map((item, index) => {
				let delay = (index - item) / 100;
				let eights = index % 8;
				let rand = Math.random() * 15;
				return (
					<span
						style={{
							animationDelay: `-${delay}s`,
							margin: `-${delay * 7}vw -5vw`,
						}}
						className="confetti-svg"
						key={index}
						data-index={item}
					>
						{eights === 0 && (
							<ConfettiSVGTriangle rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 1 && (
							<ConfettiSVGSqwiggle rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 2 && (
							<ConfettiSVGSquare rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 3 && (
							<ConfettiSVGDot rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 4 && (
							<ConfettiSVGTriangle rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 5 && (
							<ConfettiSVGSqwiggle rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 6 && (
							<ConfettiSVGSquare rand={rand} col={confettiColours[eights]} />
						)}
						{eights === 7 && (
							<ConfettiSVGDot rand={rand} col={confettiColours[eights]} />
						)}
					</span>
				);
			})}
		</div>
	);
};
const Emoji = ({ status, emjoi = "🚀" }) => {
	let array = [
		10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9, 10, 2, 4, 6, 4,
		6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9, 9, 2, 5, 6, 1,
		7, 7, 9, 8, 8, 9, 8, 7, 5, 7, 10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2,
		8, 5, 1, 7, 9, 10, 2, 4, 6, 4, 6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8,
		1, 6, 2, 3, 9, 9, 2, 5, 6, 1, 7, 7, 9, 8, 8, 9, 8, 7, 5, 7, 10, 6, 7, 6, 9,
		3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9, 10, 2, 4, 6, 4, 6, 9, 1, 5, 6,
		1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9, 9, 2, 5, 6, 1, 7, 7, 9, 8, 8,
		9, 8, 7, 5, 7, 10, 6, 7, 6, 9, 3, 2, 9, 8, 6, 1, 6, 7, 3, 2, 8, 5, 1, 7, 9,
		10, 2, 4, 6, 4, 6, 9, 1, 5, 6, 1, 7, 5, 1, 4, 6, 5, 10, 9, 8, 1, 6, 2, 3, 9,
		9, 2, 5, 6, 1, 7, 7, 9, 8, 8, 9, 8, 7, 5, 7,
	];

	return (
		<div
			className={`confetti-holder ${
				status === true ? "confetti-animate confetti-animate-ascend" : "hidden"
			} `}
		>
			{array.map((item, index) => {
				let delay = (index - item) / 100;
				let forths = index % 4;
				return (
					<span
						style={{
							animationDelay: `-${delay}s`,
							margin: `-${delay * 12}vw -5vw`,
						}}
						className="confetti-svg"
						key={index}
						data-index={item}
					>
						{forths === 0 && <span className="text-s7xl">{emjoi}</span>}
						{forths === 1 && <span className="text-s3xl">{emjoi}</span>}
						{forths === 2 && <span className="text-s5xl">{emjoi}</span>}
						{forths === 3 && <span className="text-s2xl">{emjoi}</span>}
					</span>
				);
			})}
		</div>
	);
};
